import { Injectable } from '@angular/core';
import Pusher from 'pusher-js';
import { PusherChannel } from '../../models/pusher-channel';
import { PushChannelFactory } from '../../../../push-notifications/src/models/push-channel-factory';

const PusherAppKey = '060b2aea58844be959a7';

@Injectable({
  providedIn: 'root',
})
export class PusherChannelService implements PushChannelFactory {
  constructor() {}

  createChannel(name: string): PusherChannel {
    const pusher = this.createPusher();
    return new PusherChannel(pusher.subscribe(name));
  }

  private createPusher(): Pusher {
    return new Pusher(PusherAppKey, {
      cluster: 'eu',
    });
  }
}
